import {
  SET_CUSTOM_FIELDS_DATA,
  SET_CUSTOM_FIELDS_LOADER,
  SET_CUSTOM_FIELDS_CATALOG_DATA,
  LOGOUT,
} from '~/redux/actions/action-types';

const initialState = {
  customFields: [],
  allCustomFields: [],
  rowsCount: 0,
  to: null,
  from: null,
  lastPage: null,
  currentPage: null,
  perPage: 20,
  totalCustomFieldsInDB: null,
  loading: false,
  labels: [],
  applyFilters: false,
  filterSize: null,
  filters: {},
  defaultDynamicFields: [
    {
      value: 'First Name',
      key: '{{C.FIRST_NAME}}',
      defaultValue: 'John',
    },
    {
      value: 'Last Name',
      key: '{{C.LAST_NAME}}',
      defaultValue: 'Doe',
    },
    {
      value: 'Full Name',
      key: '{{C.FIRST_NAME}} {{C.LAST_NAME}}',
      defaultValue: 'John Doe',
    },
    {
      value: 'Company Name',
      key: '{{C.COMPANY_NAME}}',
      defaultValue: 'ABC Company, Inc.',
    },
    {
      value: 'Address 1',
      key: '{{C.ADDRESS_1}}',
      defaultValue: '123 Main Street',
    },
    {
      value: 'Address 2',
      key: '{{C.ADDRESS_2}}',
      defaultValue: 'Suite 2',
    },
    {
      value: 'City',
      key: '{{C.CITY}}',
      defaultValue: 'Lawrence',
    },
    {
      value: 'State',
      key: '{{C.STATE}}',
      defaultValue: 'MA',
    },
    {
      value: 'Zip Code',
      key: '{{C.ZIP_CODE}}',
      defaultValue: '01843',
    },
    {
      value: 'Phone Number',
      key: '{{C.PHONE_NUMBER}}',
      defaultValue: '(555) 278-9389',
    },
    {
      value: 'Email',
      key: '{{C.EMAIL}}',
      defaultValue: 'johndoe@gmail.com',
    },
  ],
  defaultSenderFields: [
    {
      value: 'Sender First Name',
      key: '{{SPF.FIRST_NAME}}',
      defaultValue: 'John',
    },
    {
      value: 'Sender Last Name',
      key: '{{SPF.LAST_NAME}}',
      defaultValue: 'Doe',
    },
    {
      value: 'Sender Company Name',
      key: '{{SPF.COMPANY_NAME}}',
      defaultValue: 'ABC Company, Inc.',
    },
    {
      value: 'Sender Address 1',
      key: '{{SPF.ADDRESS_1}}',
      defaultValue: '123 Main Street',
    },
    {
      value: 'Sender Address 2',
      key: '{{SPF.ADDRESS_2}}',
      defaultValue: 'Suite 2',
    },
    {
      value: 'Sender City',
      key: '{{SPF.CITY}}',
      defaultValue: 'Lawrence',
    },
    {
      value: 'Sender State',
      key: '{{SPF.STATE}}',
      defaultValue: 'MA',
    },
    {
      value: 'Sender Zip Code',
      key: '{{SPF.ZIP_CODE}}',
      defaultValue: '01843',
    },
    {
      value: 'Sender Phone Number',
      key: '{{SPF.PHONE_NUMBER}}',
      defaultValue: '(555) 278-9389',
    },
    {
      value: 'Sender Email',
      key: '{{SPF.EMAIL}}',
      defaultValue: 'johndoe@gmail.com',
    },
  ],
  defaultPropertyFields: [
    {
      value: 'Property Address',
      key: '{{C.PROPERTY_ADDRESS}}',
      defaultValue: '912 Main Street',
    },
    {
      value: 'Property City',
      key: '{{C.PROPERTY_CITY}}',
      defaultValue: 'New York',
    },
    {
      value: 'Property State',
      key: '{{C.PROPERTY_STATE}}',
      defaultValue: 'NY',
    },
    {
      value: 'Property Zip Code',
      key: '{{C.PROPERTY_ZIP_CODE}}',
      defaultValue: '10008',
    },
    {
      value: 'Property Offer',
      key: '{{C.PROPERTY_OFFER}}',
      defaultValue: '$123,456.00',
    },
    {
      value: 'Property Written Offer',
      key: '{{ROS.WRITTEN_OFFER}}',
      defaultValue: 'One hundred twenty-three thousand four hundred fifty-six and 00/100',
    },
  ],
  defaultMiscFields: [
    {
      value: 'Mailing Date - mm/dd/yyyy',
      key: '{{MISC.MAILED_DATE}}',
      defaultValue: '12/13/2025',
    },
    {
      value: 'Mailing Date - Month DD, YYYY',
      key: '{{MISC.MAILED_DATE_MONTH_D_Y}}',
      defaultValue: 'December 13, 2025',
    },
  ],
};

const customFieldsReducers = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CUSTOM_FIELDS_DATA:
      return {
        ...state,
        customFields: payload.rows,
        rowsCount: payload.count,
        totalCustomFieldsInDB: payload.totalRecordsInDB,
        to: payload.to,
        from: payload.from,
        lastPage: payload.lastPage,
        currentPage: payload.currentPage,
        perPage: payload.perPage,
      };
    case SET_CUSTOM_FIELDS_LOADER:
      return { ...state, loading: payload };
    case SET_CUSTOM_FIELDS_CATALOG_DATA:
      return { ...state, allCustomFields: payload };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export { customFieldsReducers };
